import axios from 'axios';
import {
  API_SYNOP_STATIONS,  
  API_SYNOP_MEASUREMENTS,
  API_SYNOP_MEASUREMENTS_LAST,
  API_SYNOP_MEASUREMENTS_LOCATION
} from '../../constants';

import { toWapiSynopElement } from '../../models/synop/WapiSynopElement.js';

const synopRequests = [
  {
    id: 0,
    name: 'Станция'
  },
  {
    id: 1,
    name: 'Точка'
  }]

export default {
  state: {
    stations: [],
    measurements: [],
  },
  mutations: {
    SET_SYNOP_STATIONS: (state, payload) => {
      state.stations = payload;
    },
    SET_SYNOP_MEASUREMENTS: (state, payload) => {
      state.measurements = payload;
    }
  },
  actions: {
    FETCH_SYNOP_STATIONS: async (context, payload) => {
      try {
        const url = `${API_SYNOP_STATIONS(payload.take, payload.skip)}`;
        const response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('PUSH_SUCCESS', 'Станции успешно получены');
        context.commit('SET_SYNOP_STATIONS', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_SYNOP_REQUEST_TYPES: async (context) => {
      try {
        return synopRequests;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_SYNOP_MEASUREMENTS_LOCATION: async (context, payload) => {
      try {
        const url = `${API_SYNOP_MEASUREMENTS_LOCATION(payload.lat, payload.lon, payload.from, payload.to)}`;
        const response = await axios.get(url);

        const data = response.data.result.data;
        toWapiSynopElement(data);

        context.commit('PUSH_SUCCESS', 'Данные успешно получены');
        context.commit('SET_SYNOP_MEASUREMENTS', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_SYNOP_MEASUREMENTS_LAST: async (context, payload) => {
      try {
        const url = `${API_SYNOP_MEASUREMENTS_LAST(payload.indexes)}`;
        const response = await axios.get(url);

        const data = response.data.result.data;
        toWapiSynopElement(data);

        context.commit('PUSH_SUCCESS', 'Данные успешно получены');
        context.commit('SET_SYNOP_MEASUREMENTS', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_SYNOP_MEASUREMENTS: async (context, payload) => {
      try {
        const url = `${API_SYNOP_MEASUREMENTS(payload.indexes, payload.from, payload.to)}`;
        const response = await axios.get(url);

        const data = response.data.result.data;
        toWapiSynopElement(data);

        context.commit('PUSH_SUCCESS', 'Данные успешно получены');
        context.commit('SET_SYNOP_MEASUREMENTS', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
  },
  getters: {
    SYNOP_MEASUREMENTS: state => {
      return state.measurements;
    },
    SYNOP_STATIONS: state => {
      return state.stations;
    },
  }
}